import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Button, Spin } from 'antd';
import { STATUS } from '../../../../redux/constants';
import AuthLayout from '../../../../shared-components/AuthLayout';
import { useDispatch, useSelector } from 'react-redux';
import { checkToken } from '../../../../redux/actions/auth';
import { confirmExtendSubscription } from '../../../../redux/actions/subscription';
import moment from 'moment-timezone';

function ConfirmExtendSubscription() {
  let { uid, token } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const tokenStatus = useSelector((state) => state.auth.checkTokenStatus);
  const extendSubscriptionConfirmationStatus = useSelector(
    (state) => state.subscription.extendSubscriptionConfirmationStatus,
  );
  const subscriptionNewExpirationDate = useSelector(
    (state) => state.subscription.new_expiration_date,
  );
  let error = '';
  if (extendSubscriptionConfirmationStatus === STATUS.ERROR) {
    error =
      "Subscription can't be extended because of a server error! Please, contact help@silentpush.com.";
  }
  useEffect(() => {
    if (uid && token) {
      dispatch(checkToken({ uid, token }));
    }
  }, [uid, token]);

  const renderDescription = () => {
    return (
      <div>
        <p>
          Click on the button below to extend your subscription for more 30 days
        </p>
        <Button
          onClick={() => {
            dispatch(confirmExtendSubscription({ uid, token }));
          }}
          style={{ marginTop: 8 }}
          type={'primary'}
        >
          Extend Subscription
        </Button>
      </div>
    );
  };

  if (extendSubscriptionConfirmationStatus === STATUS.SUCCESS) {
    return (
      <AuthLayout
        style={{ width: 491 }}
        title={`Your subscription has been extended to ${moment(
          subscriptionNewExpirationDate,
        )
          .format('MMMM Do YYYY')
          .toString()}`}
        description={
          'You can now login to the Silent Push app with your credentials.'
        }
      >
        <Button
          onClick={() => {
            history.push('/login');
          }}
          style={{ marginTop: 8 }}
          type={'primary'}
        >
          Login
        </Button>
      </AuthLayout>
    );
  }
  if (tokenStatus === STATUS.LOADED) {
    return (
      <AuthLayout
        title={'Extend Your Subscription'}
        description={renderDescription()}
        error={error}
      ></AuthLayout>
    );
  }
  if (tokenStatus === STATUS.ERROR) {
    return (
      <AuthLayout
        title="Your invitation link has expired"
        description={
          'Please contact help@silentpush.com to re-send a new fresh invitation link to extend your subscription'
        }
      ></AuthLayout>
    );
  }
  return (
    <div
      style={{
        display: 'flex',
        height: '95vh',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin />{' '}
    </div>
  );
}

export default ConfirmExtendSubscription;
